import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OfflineQueueService, StoredRequest } from './offline-queue.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class OfflineSyncService {
  private queueStatus$ = new BehaviorSubject<StoredRequest | null>(null);
  private isSyncing = false;
  constructor(
    private offlineQueue: OfflineQueueService,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private ngZone: NgZone,
  ) {
    // ✅ نراقب تغير حالة الإنترنت
    window.addEventListener('online', () => this.syncRequests());
  }
  async queueRequest(req: StoredRequest): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    await this.offlineQueue.addRequest(req as any);

    this.ngZone.run(() => {
      this.snackBar.open('تم حفظ الطلب، سيتم معالجته عند توفر الإنترنت', '', {
        duration: 3000,
      });
    });
  }
  /**
   * مزامنة جميع الطلبات عند توفر الإنترنت
   */
  async syncRequests(): Promise<void> {
    if (this.isSyncing) return; // حماية من التكرار
    this.isSyncing = true;

    const requests = await this.offlineQueue.getRequests();
    if (!requests.length) {
      this.isSyncing = false;
      return;
    }

    let successCount = 0;
    let failCount = 0;

    for (const req of requests) {
      try {
        const httpReq = this.offlineQueue.rebuildHttpRequest(req);
        await this.http.request(httpReq).toPromise();
        await this.offlineQueue.removeRequest(req.id);
        successCount++;
      } catch (err) {
        console.log(err);
        failCount++;
      }
    }

    this.ngZone.run(() => {
      if (failCount === 0) {
        this.snackBar.open('تم إرسال جميع الطلبات المحفوظة بنجاح ✅', '', {
          duration: 3000,
        });
      } else if (successCount > 0) {
        this.snackBar.open(
          `تم إرسال ${successCount} طلب وفشل ${failCount} طلب`,
          '',
          { duration: 4000 },
        );
      } else {
        this.snackBar.open('فشل إرسال جميع الطلبات المحفوظة ❌', '', {
          duration: 3000,
        });
      }
    });

    this.isSyncing = false;
  }
  init() {
    window.addEventListener('online', () => this.flushQueue());
  }

  getQueueStatus(): Observable<StoredRequest | null> {
    return this.queueStatus$.asObservable();
  }

  private async flushQueue() {
    const requests = await this.offlineQueue.getRequests();
    for (const req of requests) {
      if (req.status !== 'pending') continue;

      const httpReq = this.offlineQueue.rebuildHttpRequest(req);
      this.http.request(httpReq).subscribe({
        next: async () => {
          await this.offlineQueue.removeRequest(req.id);
          this.queueStatus$.next({ ...req, status: 'sent' });
        },
        error: (err) => {
          console.log(err);
          this.queueStatus$.next({ ...req, status: 'failed' });
        },
      });
    }
  }
}
